import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

const UserPanel = ({ partsData}) => {
 
const machineId = Number(localStorage.getItem("selectedMachineId"));
 
  return (
    <React.Fragment>
       <Row>
              
      <Col xl={7} style={{ marginBottom: "" }}>
      <Row className="justify-content-center g-4">
        <Col xl={4} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-primary" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="ri-time-line"></i>
                    </div>
                  </div>
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Running hours</p>
                  <h5 className="mb-3">{partsData.total_running_hours || 0}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={4} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-success" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="ri-checkbox-circle-line"></i>
                    </div>
                  </div>
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Good Parts</p>
                  <h5 className="mb-3">{partsData.good_parts||0}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={4} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-danger" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="ri-close-circle-line"></i>
                    </div>
                  </div>
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Bad Parts</p>
                  <h5 className="mb-3">{partsData.bad_parts||0}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
</Row>
</Col>
 <Col xl={5} style={{ marginBottom: "" }}>
<Row>
        <Col xl={6} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-primary" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="ri-group-line"></i>
                    </div>
                  </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Total Parts</p>
                  <h5 className="mb-3">{partsData.total_parts||0}</h5>
                  {/* Commented section remains the same */}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
         <Col xl={6} sm={6}>
          <Card className="m-0">
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  {/* Replace RadialChart with icon */}
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-primary" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="ri-time-line"></i>
                    </div>
                  </div>
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Stopped hours</p>
                  <h5 className="mb-3">{partsData.stopped_time||0}</h5>
                  {/* Commented section remains the same */}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UserPanel;
